export default {
    publicQuote: {},
    appSalesInfo: {},
    paymentSubtype: {},
    invoice: {},
    publicInvoice: {},
    processing: false,
};
